import { Component, OnInit } from '@angular/core';
import { LookupScreenService } from '../../../../../../services/lookup-screen.service';
import { Router } from '@angular/router';
import { DoctorBreadcrumbService } from '../../../../shared/breadcrumb.service';
import { Title } from '@angular/platform-browser';
import { TraceClassDecorator } from '@sentry/angular';
import { ProviderStateService } from 'src/app/services/provider-state.service';

export interface searchBody {
    current_user_guid: string;
    e_email?: string;
    name?: string;
    records_per_page: number;
    page_no: number;
}

@TraceClassDecorator()
@Component({
    selector: 'app-lookup-search-d',
    templateUrl: './lookup-search-d.component.html',
    styleUrls: [
        './lookup-search-d.component.css',
        '../../../../../../../assets/css/custom-egd.css'
    ]
})
export class LookupSearchDComponent implements OnInit {
    error: string = '';
    searchType: any;
    inptype: string;
    inpdata: string;
    slug: string = "";
    Type: any[] = [
        { name: 'EMAIL', value: 'e_email' },
        { name: 'Name', value: 'name' }
    ];
    body: searchBody;
    loading = false;

    constructor(
        private lookupservice: LookupScreenService,
        private router: Router,
        private titleService: Title,
        private breadcrumbService: DoctorBreadcrumbService,
        private readonly providerstateService: ProviderStateService
    ) {

    }

    isValidData(type: string, data: string): boolean {
        switch (type) {
            case 'e_email':
                const re =
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (re.test(data.toLowerCase())) {
                    this.body = {
                        current_user_guid: sessionStorage.getItem('userid'),
                        e_email: data,
                        records_per_page: 5,
                        page_no: 1
                    };
                    return true;
                } else {
                    this.error = 'Invalid  Email !';
                    return false;
                }
            case 'name':
                if (data.length >= 1 && data.match(/^[a-zA-Z_ ]{1,}$/)) {
                    this.body = {
                        current_user_guid: sessionStorage.getItem('userid'),
                        name: data,
                        records_per_page: 5,
                        page_no: 1
                    };
                    return true;
                } else {
                    this.error = 'Invalid  Name  !';
                    return false;
                }
        }
    }

    getInput(inptype: string, inpdata: string) {
        if (this.isValidData(inptype, inpdata)) {
            this.loading = true;
            this.lookupservice
                .searchDoctorsDetails(this.body)
                .then((resp) => {
                    if (resp) {
                        this.router.navigate(['/' + this.slug + '/doctor/lookup-list-d'], { queryParams: { searchType: inptype, searchData: inpdata } });
                    } else {
                        this.loading = false;
                        this.error = 'No Record Found';
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = error.error.message;
                });
        }
    }

    ngOnInit(): void {
        this.slug = this.providerstateService.getProviderSlug();
        this.breadcrumbService.setItems([
            { label: 'Dashboard', routerLink: [`/${this.slug}/doctor`] },
            { label: 'Lookup Screen' },
            { label: 'Lookup Doctors' }
        ]);
        this.titleService.setTitle('Dashboard - Lookup Doctors');
    }
}
